import React from 'react';
import CustomDataGrid from '../../../../../../shared/components/CustomDataGrid';
import { useProjectColumns } from '../../../../../../shared/hooks/useProjectColumns';
import { IProject } from '../../../../../../shared/interfaces/projects/IProject';

interface IProps {
  data: IProject[];
}
const ProjectsTab = ({ data }: IProps) => {
  const columns = useProjectColumns(
    () => {},
    () => {},
    true,
  );

  return (
    <CustomDataGrid
      columns={columns}
      rows={data || []}
      rowCount={-1}
      setPagination={() => {}}
      pagination={{ page: 1, perPage: -1 }}
      loading={data === undefined}
      hasNextPage={false}
    />
  );
};

export default ProjectsTab;
